import styled from 'styled-components';
import { FONT_SIZES } from 'variables/typography';

export const Header = styled.div`
  font-size: ${FONT_SIZES.size2};
`;
